import { MaskedInput } from '@pay-com/components'
import {
  FieldPath,
  FieldValues,
  useController,
  useFormContext
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { TaxNumberType } from 'generated/graphql'
import { ICustomFieldComponentProps } from 'types'
import { getErrorMessage } from 'utils/get-error-message'

type TaxpayerIdNumberFieldProps = ICustomFieldComponentProps<
  FieldValues,
  FieldPath<FieldValues>
>

const taxNumberFormat: Record<TaxNumberType, string> = {
  [TaxNumberType.Ssn]: '###-##-####',
  [TaxNumberType.Itin]: '###-##-####',
  [TaxNumberType.Ein]: '##-#######'
}

export const TaxpayerIdNumberField = ({
  name,
  label,
  placeholder,
  disabled
}: TaxpayerIdNumberFieldProps) => {
  const { control, watch } = useFormContext()
  const { field, fieldState } = useController({ name, control })
  const { t } = useTranslation('errors')

  const taxpayerIdType = watch('taxInfo.taxpayerIdType') as TaxNumberType
  const format =
    taxNumberFormat[taxpayerIdType] ?? taxNumberFormat[TaxNumberType.Ssn]

  return (
    <MaskedInput
      label={label}
      placeholder={placeholder}
      value={(field.value as string | undefined) ?? ''}
      disabled={disabled}
      error={Boolean(fieldState.error)}
      errorMessage={getErrorMessage(t, fieldState.error?.message)}
      inputSize="medium"
      containerProps={{ style: { width: '100%' } }}
      format={format}
      name={field.name}
      onChange={e => field.onChange(e.target.value)}
      onBlur={field.onBlur}
    />
  )
}
